// src/components/MangoModal/MangoModal.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useCart } from "../../context/CartContext";
import { FaMinus, FaPlus, FaTimes } from "react-icons/fa";
import "./mango-modal.css";

const MangoModal = ({ mango, closeModal }) => {
  const { cart, setCart } = useCart();
  const [selectedVariant, setSelectedVariant] = useState(
    mango?.variants?.[0] || null,
  );
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    if (mango && window.fbq) {
      window.fbq("track", "ViewContent", {
        content_ids: [`mango_${mango.id}`],
        content_name: mango.name,
        content_category: "Mango",
        content_type: "product",
        value: selectedVariant?.price || 0,
        currency: "BDT",
      });
      console.log("👁️ ViewContent event fired for mango:", mango.name);
    }
  }, [mango, selectedVariant]);

  if (!mango) return null;

  const increaseQuantity = () => setQuantity(quantity + 1);
  const decreaseQuantity = () => setQuantity(quantity > 1 ? quantity - 1 : 1);

  const handleVariantSelect = (variant) => {
    setSelectedVariant(variant);
  };

  //   const handleAddToCart = () => {
  //     const cartItem = {
  //       _id: `mango_${mango.id}_${selectedVariant.weight}`,
  //       title: `${mango.name} - ${selectedVariant.weight}`,
  //       price: selectedVariant.price,
  //       imageUrl: mango.image,
  //       category: ["mango"],
  //       quantity: quantity,
  //       isMango: true,
  //       mangoId: mango.id,
  //       weight: selectedVariant.weight,
  //     };

  //     const updatedCart = [...cart];
  //     const existingItemIndex = updatedCart.findIndex(
  //       (item) => item._id === cartItem._id,
  //     );

  //     if (existingItemIndex !== -1) {
  //       updatedCart[existingItemIndex].quantity = quantity;
  //     } else {
  //       updatedCart.push(cartItem);
  //     }

  //     toast(`${mango.name} - ${selectedVariant.weight} added to cart!`);
  //     setCart(updatedCart);

  //     if (window.fbq) {
  //       window.fbq("track", "AddToCart", {
  //         content_ids: [cartItem._id],
  //         content_name: cartItem.title,
  //         content_type: "product",
  //         value: selectedVariant.price * quantity,
  //         currency: "BDT",
  //       });
  //       console.log("🛒 AddToCart event fired for mango:", cartItem.title);
  //     }
  //   };
  const handleAddToCart = () => {
    const cartItem = {
      _id: `mango_${mango.id}_${selectedVariant.weight}`,
      title: `${mango.name} - ${selectedVariant.weight}`,
      price: selectedVariant.price,
      imageUrl: mango.image,
      category: ["mango"],
      quantity: quantity,
      isMango: true, // ✅ Important: Mark as mango
      mangoId: mango.id, // ✅ Store original mango ID
      weight: selectedVariant.weight, // ✅ Store weight
      // Add these for better tracking
      originalName: mango.name,
      origin: mango.origin,
      description: mango.description,
    };

    const updatedCart = [...cart];
    const existingItemIndex = updatedCart.findIndex(
      (item) => item._id === cartItem._id,
    );

    if (existingItemIndex !== -1) {
      updatedCart[existingItemIndex].quantity = quantity;
    } else {
      updatedCart.push(cartItem);
    }

    toast(`${mango.name} - ${selectedVariant.weight} added to cart!`);
    setCart(updatedCart);

    if (window.fbq) {
      window.fbq("track", "AddToCart", {
        content_ids: [cartItem._id],
        content_name: cartItem.title,
        content_type: "product",
        value: selectedVariant.price * quantity,
        currency: "BDT",
      });
      console.log("🛒 AddToCart event fired for mango:", cartItem.title);
    }
  };

  const totalPrice = selectedVariant ? selectedVariant.price * quantity : 0;

  return (
    <div className="mango-modal-overlay" onClick={closeModal}>
      <div className="mango-modal" onClick={(e) => e.stopPropagation()}>
        <button className="mango-modal-close" onClick={closeModal}>
          <FaTimes />
        </button>

        <div className="mango-modal-content">
          <div className="mango-modal-image-wrapper">
            <img
              src={mango.image}
              alt={mango.name}
              className="mango-modal-image"
            />
            <div className="mango-modal-badge">{mango.origin}</div>
          </div>

          <div className="mango-modal-details">
            <h2 className="mango-modal-title">{mango.name}</h2>
            <p className="mango-modal-description">{mango.description}</p>

            <div className="mango-modal-variants">
              <h4>Select Weight:</h4>
              <div className="mango-variant-options">
                {mango.variants.map((variant, index) => (
                  <button
                    key={index}
                    className={`mango-variant-btn ${
                      selectedVariant?.weight === variant.weight ? "active" : ""
                    }`}
                    onClick={() => handleVariantSelect(variant)}
                  >
                    {variant.weight}
                    <br />
                    <span>৳{variant.price}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="mango-modal-quantity">
              <h4>Quantity:</h4>
              <div className="mango-quantity-control">
                <button onClick={decreaseQuantity} className="quantity-btn">
                  <FaMinus />
                </button>
                <input
                  type="number"
                  value={quantity}
                  min="1"
                  onChange={(e) => {
                    let value = parseInt(e.target.value, 10);
                    if (isNaN(value) || value < 1) value = 1;
                    setQuantity(value);
                  }}
                />
                <button onClick={increaseQuantity} className="quantity-btn">
                  <FaPlus />
                </button>
              </div>
            </div>

            <div className="mango-modal-total">
              <span>Total:</span>
              <span className="mango-total-price">৳{totalPrice}</span>
            </div>

            <div className="mango-modal-actions">
              <button onClick={handleAddToCart} className="mango-add-btn">
                Add to Cart
              </button>
              <Link to="/order" className="mango-view-order-btn">
                View Order
              </Link>
            </div>
          </div>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </div>
    </div>
  );
};

export default MangoModal;
